export default __webpack_public_path__ + "static/media/PictureMatthias.1ec8813a.jpg";